import { Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "@/features/auth/LoginPage";
import { Layout } from "@/components/Layout";
import { AuthGuard } from "@/components/AuthGuard";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { ItemsPage } from "@/features/catalog/ItemsPage";
import { VendorsPage } from "@/features/catalog/VendorsPage";
import { CustomersPage } from "@/features/catalog/CustomersPage";
import { UomsPage } from "@/features/catalog/UomsPage";
import { ItemCategoriesPage } from "@/features/catalog/ItemCategoriesPage";
import { ItemFormsPage } from "@/features/catalog/ItemFormsPage";
import { ItemRoutesPage } from "@/features/catalog/ItemRoutesPage";
import { GenericNamesPage } from "@/features/catalog/GenericNamesPage";
import { SupplyTypesPage } from "@/features/catalog/SupplyTypesPage";
import { VendorItemsPage } from "@/features/catalog/VendorItemsPage";
import { LasaPairsPage } from "@/features/catalog/LasaPairsPage";
import { ItemSubstitutesPage } from "@/features/catalog/ItemSubstitutesPage";
import { ServicesPage } from "@/features/catalog/ServicesPage";
import { ServiceGroupsPage } from "@/features/catalog/ServiceGroupsPage";
import { ServiceChargesPage } from "@/features/catalog/ServiceChargesPage";
import { AdmissionTypesPage } from "@/features/catalog/AdmissionTypesPage";
import { PersonTypesPage } from "@/features/catalog/PersonTypesPage";
import { InsuranceSchemesPage } from "@/features/catalog/InsuranceSchemesPage";
import { CurrenciesPage } from "@/features/catalog/CurrenciesPage";
import { StockPage } from "@/features/inventory/StockPage";
import { StockAdjustmentsPage } from "@/features/inventory/StockAdjustmentsPage";
import { CreateStockAdjustmentPage } from "@/features/inventory/CreateStockAdjustmentPage";
import { StockAdjustmentDetailPage } from "@/features/inventory/StockAdjustmentDetailPage";
import { StockWriteOffsPage } from "@/features/inventory/StockWriteOffsPage";
import { CreateStockWriteOffPage } from "@/features/inventory/CreateStockWriteOffPage";
import { StockWriteOffDetailPage } from "@/features/inventory/StockWriteOffDetailPage";
import { InternalTransfersPage } from "@/features/inventory/InternalTransfersPage";
import { CreateInternalTransferPage } from "@/features/inventory/CreateInternalTransferPage";
import { InternalTransferDetailPage } from "@/features/inventory/InternalTransferDetailPage";
import { StockTakesPage } from "@/features/inventory/StockTakesPage";
import { CreateStockTakePage } from "@/features/inventory/CreateStockTakePage";
import { StockTakeDetailPage } from "@/features/inventory/StockTakeDetailPage";
import { NearExpiryPage } from "@/features/inventory/NearExpiryPage";
import { PredictiveReorderPage } from "@/features/inventory/PredictiveReorderPage";
import { NarcoticRegisterPage } from "@/features/inventory/NarcoticRegisterPage";
import { ReorderQueuePage } from "@/features/procurement/ReorderQueuePage";
import { PurchaseInvoicesPage } from "@/features/procurement/PurchaseInvoicesPage";
import { CreatePurchaseInvoicePage } from "@/features/procurement/CreatePurchaseInvoicePage";
import { CreateDirectPurchaseInvoicePage } from "@/features/procurement/CreateDirectPurchaseInvoicePage";
import { PurchaseInvoiceDetailPage } from "@/features/procurement/PurchaseInvoiceDetailPage";
import { ManualJournalPage } from "@/features/accounting/ManualJournalPage";
import { JournalsListPage } from "@/features/accounting/JournalsListPage";
import { JournalEntryDetailPage } from "@/features/accounting/JournalEntryDetailPage";
import { PeriodsPage } from "@/features/accounting/PeriodsPage";
import { ChartOfAccountsPage } from "@/features/accounting/ChartOfAccountsPage";
import { ReportsHubPage } from "@/features/reporting/ReportsHubPage";
import { TrialBalancePage } from "@/features/reporting/TrialBalancePage";
import { StockOnHandPage } from "@/features/reporting/StockOnHandPage";
import { PoStatusReportPage } from "@/features/reporting/PoStatusReportPage";
import { DailySalesReportPage } from "@/features/reporting/DailySalesReportPage";
import { AuditLogPage } from "@/features/admin/AuditLogPage";
import { DemoGuidePage } from "@/features/demo/DemoGuidePage";
import { PermissionMatrixPage } from "@/features/admin/PermissionMatrixPage";
import { FeatureFlagsPage } from "@/features/admin/FeatureFlagsPage";
import { TenantSettingsPage } from "@/features/admin/TenantSettingsPage";
import { AppearancePage } from "@/features/admin/AppearancePage";
import { BranchesPage } from "@/features/admin/BranchesPage";
import { WarehousesPage } from "@/features/admin/WarehousesPage";
import { WarehouseLocationsPage } from "@/features/admin/WarehouseLocationsPage";
import { ItemBinsPage } from "@/features/inventory/ItemBinsPage";
import { TransferOrdersPage } from "@/features/transfer/TransferOrdersPage";
import { CreateTransferOrderPage } from "@/features/transfer/CreateTransferOrderPage";
import { TransferOrderDetailPage } from "@/features/transfer/TransferOrderDetailPage";
import { TransferRequisitionsPage } from "@/features/transfer/TransferRequisitionsPage";
import { CreateTransferRequisitionPage } from "@/features/transfer/CreateTransferRequisitionPage";
import { TransferRequisitionDetailPage } from "@/features/transfer/TransferRequisitionDetailPage";
import { ShipmentsPage } from "@/features/transport/ShipmentsPage";
import { ShipmentDetailPage } from "@/features/transport/ShipmentDetailPage";
import { CarriersPage } from "@/features/transport/CarriersPage";
import { VehiclesPage } from "@/features/transport/VehiclesPage";
import { DriversPage } from "@/features/transport/DriversPage";
import { PriceListsPage } from "@/features/pricing/PriceListsPage";
import { TariffsPage } from "@/features/pricing/TariffsPage";
import { PackagesPage } from "@/features/pricing/PackagesPage";
import { ConsultantsPage } from "@/features/sales/ConsultantsPage";
import { ScheduleRegisterPage } from "@/features/sales/ScheduleRegisterPage";
import { ServiceRevenueByGroupPage } from "@/features/reporting/ServiceRevenueByGroupPage";
import { PurchaseRequisitionsPage } from "@/features/procurement/PurchaseRequisitionsPage";
import { CreatePurchaseRequisitionPage } from "@/features/procurement/CreatePurchaseRequisitionPage";
import { PurchaseRequisitionDetailPage } from "@/features/procurement/PurchaseRequisitionDetailPage";
import { QuotationsPage } from "@/features/procurement/QuotationsPage";
import { ConsolidatedStockPage } from "@/features/reporting/ConsolidatedStockPage";
import { AgingPage } from "@/features/reporting/AgingPage";
import { IpBillingPage } from "@/features/sales/IpBillingPage";
import { PurchaseOrdersPage } from "@/features/procurement/PurchaseOrdersPage";
import { CreatePurchaseOrderPage } from "@/features/procurement/CreatePurchaseOrderPage";
import { PurchaseOrderDetailPage } from "@/features/procurement/PurchaseOrderDetailPage";
import { GrnsPage } from "@/features/procurement/GrnsPage";
import { CreateGrnPage } from "@/features/procurement/CreateGrnPage";
import { GrnDetailPage } from "@/features/procurement/GrnDetailPage";
import { SalesInvoicesPage } from "@/features/sales/SalesInvoicesPage";
import { CreateSalesInvoicePage } from "@/features/sales/CreateSalesInvoicePage";
import { SalesInvoiceDetailPage } from "@/features/sales/SalesInvoiceDetailPage";
import { SalesReturnPage } from "@/features/sales/SalesReturnPage";
import { UsersPage } from "@/features/admin/UsersPage";
import { RolesPage } from "@/features/admin/RolesPage";
import { WardIssuesPage } from "@/features/hospital/WardIssuesPage";
import { CreateWardIssuePage } from "@/features/hospital/CreateWardIssuePage";
import { OtConsumptionsPage } from "@/features/hospital/OtConsumptionsPage";
import { CreateOtConsumptionPage } from "@/features/hospital/CreateOtConsumptionPage";
import { CssdTraysPage } from "@/features/hospital/CssdTraysPage";
import { SurgicalKitsPage } from "@/features/hospital/SurgicalKitsPage";
import { HealNTrackPage } from "@/features/integration/HealNTrackPage";
import { PrescriptionQueuePage } from "@/features/sales/PrescriptionQueuePage";
import { EInvoicesPage } from "@/features/integration/EInvoicesPage";
import { EWayBillsPage } from "@/features/integration/EWayBillsPage";
import { DiagnosticsDepartmentsPage, DepartmentFormPage } from "@/features/diagnostics/masters/DepartmentsPage";
// Diagnostics masters — listing + create/edit screens (shared scaffold in features/diagnostics/masters).
import { DiagnosticsLabTestsPage, LabTestFormPage } from "@/features/diagnostics/masters/LabTestsPage";
import { DiagnosticsSpecimensPage, SpecimenFormPage } from "@/features/diagnostics/masters/SpecimensPage";
import { DiagnosticsContainersPage, ContainerFormPage } from "@/features/diagnostics/masters/ContainersPage";
import { DiagnosticsRejectionReasonsPage, RejectionReasonFormPage } from "@/features/diagnostics/masters/RejectionReasonsPage";
import { DiagnosticsReportTemplatesPage, ReportTemplateFormPage } from "@/features/diagnostics/masters/ReportTemplatesPage";
import { DiagnosticsRoomsPage, RoomFormPage } from "@/features/diagnostics/masters/RoomsPage";
import { DiagnosticsMachinesPage, MachineFormPage } from "@/features/diagnostics/masters/MachinesPage";
import { ModalityFormPage } from "@/features/diagnostics/masters/ModalitiesPage";
import { ProcedureFormPage } from "@/features/diagnostics/masters/ProceduresPage";
import { NewDiagnosticOrderPage } from "@/features/diagnostics/NewOrderPage";
import { LabWorkbenchPage } from "@/features/diagnostics/LabWorkbenchPage";
import { CriticalValuesPage } from "@/features/diagnostics/CriticalValuesPage";
import { DiagnosticsQcPage } from "@/features/diagnostics/QcPage";
import { RadiologyModalitiesPage } from "@/features/diagnostics/masters/ModalitiesPage";
import { RadiologyProceduresPage } from "@/features/diagnostics/masters/ProceduresPage";
import { RadiologySchedulingPage } from "@/features/diagnostics/RadiologySchedulingPage";
import { RadiologyReportingPage } from "@/features/diagnostics/RadiologyReportingPage";
import { DispatchPage } from "@/features/diagnostics/DispatchPage";
import { LabTatPage } from "@/features/diagnostics/LabTatPage";
import { DiagnosticsNotificationsPage } from "@/features/diagnostics/NotificationsPage";
import { DiagnosticsMicrobiologyPage } from "@/features/diagnostics/MicrobiologyPage";
import { DiagnosticsHistopathologyPage } from "@/features/diagnostics/HistopathologyPage";
import { DiagnosticsOutsourcedPage } from "@/features/diagnostics/OutsourcedPage";
import { DiagnosticsSafetyPage } from "@/features/diagnostics/SafetyPage";
import { DiagnosticsPacsPage } from "@/features/diagnostics/PacsPage";
import { DiagnosticsCriticalFindingsPage } from "@/features/diagnostics/CriticalFindingsPage";
import { DiagnosticsLabDashboardPage } from "@/features/diagnostics/LabDashboardPage";
import { DiagnosticsRadiologyDashboardPage } from "@/features/diagnostics/RadiologyDashboardPage";
import { DiagnosticsAnalyticsHubPage } from "@/features/diagnostics/AnalyticsHubPage";
import { DiagnosticsCategoriesPage, CategoryFormPage } from "@/features/diagnostics/masters/CategoriesPage";
import { DiagnosticsFacilitiesPage, FacilityFormPage } from "@/features/diagnostics/masters/FacilitiesPage";
import { FacilityLoadPage } from "@/features/diagnostics/FacilityLoadPage";
import { DiagnosticsProfilesPage, ProfileFormPage } from "@/features/diagnostics/masters/ProfilesPage";
import { DiagnosticsReflexRulesPage } from "@/features/diagnostics/ReflexRulesPage";
import { DiagnosticOrdersListPage } from "@/features/diagnostics/OrdersPage";
import { DiagnosticSamplesPage } from "@/features/diagnostics/SamplesPage";
import { DiagnosticResultsPage } from "@/features/diagnostics/ResultsPage";
import { RadiologyWorklistPage } from "@/features/diagnostics/RadiologyWorklistPage";
import { SampleCollectionPage } from "@/features/diagnostics/SampleCollectionPage";
import { BarcodePage } from "@/features/diagnostics/BarcodePage";
import { DiagnosticOrderQueuePage } from "@/features/diagnostics/DiagnosticOrderQueuePage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <Layout />
          </AuthGuard>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />

        <Route path="catalog/items" element={<ItemsPage />} />
        <Route path="catalog/vendors" element={<VendorsPage />} />
        <Route path="catalog/vendor-items" element={<VendorItemsPage />} />
        <Route path="catalog/customers" element={<CustomersPage />} />
        <Route path="catalog/uoms" element={<UomsPage />} />
        <Route path="catalog/item-categories" element={<ItemCategoriesPage />} />
        <Route path="catalog/item-forms" element={<ItemFormsPage />} />
        <Route path="catalog/item-routes" element={<ItemRoutesPage />} />
        <Route path="catalog/generic-names" element={<GenericNamesPage />} />
        <Route path="catalog/supply-types" element={<SupplyTypesPage />} />
        <Route path="catalog/lasa" element={<LasaPairsPage />} />
        <Route path="catalog/item-substitutes" element={<ItemSubstitutesPage />} />
        <Route path="catalog/services" element={<ServicesPage />} />
        <Route path="catalog/service-groups" element={<ServiceGroupsPage />} />
        <Route path="catalog/service-charges" element={<ServiceChargesPage />} />
        <Route path="catalog/admission-types" element={<AdmissionTypesPage />} />
        <Route path="catalog/person-types" element={<PersonTypesPage />} />
        <Route path="catalog/insurance-schemes" element={<InsuranceSchemesPage />} />
        <Route path="catalog/currencies" element={<CurrenciesPage />} />

        <Route path="inventory/stock" element={<StockPage />} />
        <Route path="inventory/item-bins" element={<ItemBinsPage />} />
        <Route path="inventory/adjustments" element={<StockAdjustmentsPage />} />
        <Route path="inventory/adjustments/new" element={<CreateStockAdjustmentPage />} />
        <Route path="inventory/adjustments/:id" element={<StockAdjustmentDetailPage />} />
        <Route path="inventory/writeoffs" element={<StockWriteOffsPage />} />
        <Route path="inventory/writeoffs/new" element={<CreateStockWriteOffPage />} />
        <Route path="inventory/writeoffs/:id" element={<StockWriteOffDetailPage />} />
        <Route path="inventory/internal-transfers" element={<InternalTransfersPage />} />
        <Route path="inventory/internal-transfers/new" element={<CreateInternalTransferPage />} />
        <Route path="inventory/internal-transfers/:id" element={<InternalTransferDetailPage />} />
        <Route path="inventory/stocktakes" element={<StockTakesPage />} />
        <Route path="inventory/stocktakes/new" element={<CreateStockTakePage />} />
        <Route path="inventory/stocktakes/:id" element={<StockTakeDetailPage />} />
        <Route path="inventory/near-expiry" element={<NearExpiryPage />} />
        <Route path="inventory/predictive-reorder" element={<PredictiveReorderPage />} />
        <Route path="inventory/narcotic-register" element={<NarcoticRegisterPage />} />
        <Route path="procurement/reorder-queue" element={<ReorderQueuePage />} />
        <Route path="procurement/purchase-invoices" element={<PurchaseInvoicesPage />} />
        <Route path="procurement/purchase-invoices/new" element={<CreatePurchaseInvoicePage />} />
        <Route path="procurement/purchase-invoices/direct" element={<CreateDirectPurchaseInvoicePage />} />
        <Route path="procurement/purchase-invoices/:id" element={<PurchaseInvoiceDetailPage />} />
        <Route path="procurement/quotations" element={<QuotationsPage />} />

        <Route path="accounting/journals" element={<JournalsListPage />} />
        <Route path="accounting/journals/new" element={<ManualJournalPage />} />
        <Route path="accounting/journals/:id" element={<JournalEntryDetailPage />} />
        <Route path="accounting/periods" element={<PeriodsPage />} />
        <Route path="accounting/chart-of-accounts" element={<ChartOfAccountsPage />} />

        <Route path="reports" element={<ReportsHubPage />} />
        <Route path="reports/trial-balance" element={<TrialBalancePage />} />
        <Route path="reports/stock-on-hand" element={<StockOnHandPage />} />
        <Route path="reports/po-status" element={<PoStatusReportPage />} />
        <Route path="reports/daily-sales" element={<DailySalesReportPage />} />

        <Route path="admin/audit" element={<AuditLogPage />} />
        <Route path="admin/permissions" element={<PermissionMatrixPage />} />
        <Route path="admin/feature-flags" element={<FeatureFlagsPage />} />
        <Route path="admin/tenant-settings" element={<TenantSettingsPage />} />
        <Route path="admin/appearance" element={<AppearancePage />} />
        <Route path="admin/branches" element={<BranchesPage />} />
        <Route path="admin/warehouses" element={<WarehousesPage />} />
        <Route path="admin/warehouse-locations" element={<WarehouseLocationsPage />} />

        <Route path="warehouse/transfers" element={<TransferOrdersPage />} />
        <Route path="warehouse/transfers/new" element={<CreateTransferOrderPage />} />
        <Route path="warehouse/transfers/:id" element={<TransferOrderDetailPage />} />
        <Route path="warehouse/transfer-requisitions" element={<TransferRequisitionsPage />} />
        <Route path="warehouse/transfer-requisitions/new" element={<CreateTransferRequisitionPage />} />
        <Route path="warehouse/transfer-requisitions/:id" element={<TransferRequisitionDetailPage />} />

        <Route path="transport/shipments" element={<ShipmentsPage />} />
        <Route path="transport/shipments/:id" element={<ShipmentDetailPage />} />
        <Route path="transport/carriers" element={<CarriersPage />} />
        <Route path="transport/vehicles" element={<VehiclesPage />} />
        <Route path="transport/drivers" element={<DriversPage />} />
        <Route path="pricing/price-lists" element={<PriceListsPage />} />
        <Route path="pricing/tariffs" element={<TariffsPage />} />
        <Route path="pricing/packages" element={<PackagesPage />} />
        <Route path="sales/consultants" element={<ConsultantsPage />} />
        <Route path="sales/schedule-register" element={<ScheduleRegisterPage />} />
        <Route path="reports/service-revenue" element={<ServiceRevenueByGroupPage />} />
        <Route path="procurement/purchase-requisitions" element={<PurchaseRequisitionsPage />} />
        <Route path="procurement/purchase-requisitions/new" element={<CreatePurchaseRequisitionPage />} />
        <Route path="procurement/purchase-requisitions/:id" element={<PurchaseRequisitionDetailPage />} />
        <Route path="reports/consolidated-stock" element={<ConsolidatedStockPage />} />
        <Route path="reports/aging" element={<AgingPage />} />
        <Route path="sales/ip-billing" element={<IpBillingPage />} />
        <Route path="demo-guide" element={<DemoGuidePage />} />

        <Route path="procurement/purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="procurement/purchase-orders/new" element={<CreatePurchaseOrderPage />} />
        <Route path="procurement/purchase-orders/:id" element={<PurchaseOrderDetailPage />} />
        <Route path="procurement/grns" element={<GrnsPage />} />
        <Route path="procurement/grns/new" element={<CreateGrnPage />} />
        <Route path="procurement/grns/:id" element={<GrnDetailPage />} />

        <Route path="sales/invoices" element={<SalesInvoicesPage />} />
        <Route path="sales/invoices/new" element={<CreateSalesInvoicePage />} />
        <Route path="sales/invoices/:id" element={<SalesInvoiceDetailPage />} />
        {/* Returns hang off the bill rather than standing alone — there is no credit note
            without an invoice behind it. */}
        <Route path="sales/invoices/:invoiceId/return" element={<SalesReturnPage />} />

        <Route path="admin/users" element={<UsersPage />} />
        <Route path="admin/roles" element={<RolesPage />} />

        <Route path="hospital/ward" element={<WardIssuesPage />} />
        <Route path="hospital/ward/new" element={<CreateWardIssuePage />} />
        <Route path="hospital/ot" element={<OtConsumptionsPage />} />
        <Route path="hospital/ot/new" element={<CreateOtConsumptionPage />} />
        <Route path="hospital/cssd" element={<CssdTraysPage />} />
        <Route path="hospital/surgical-kits" element={<SurgicalKitsPage />} />
        <Route path="integration/healntrack" element={<HealNTrackPage />} />
        <Route path="sales/prescription-queue" element={<PrescriptionQueuePage />} />
        <Route path="integration/einvoices" element={<EInvoicesPage />} />
        <Route path="integration/ewaybills" element={<EWayBillsPage />} />
        <Route path="diagnostics/departments" element={<DiagnosticsDepartmentsPage />} />
        <Route path="diagnostics/departments/new" element={<DepartmentFormPage />} />
        <Route path="diagnostics/departments/:id/edit" element={<DepartmentFormPage />} />
        {/* The old combined masters screen split into the dedicated master routes below. */}
        <Route path="diagnostics/masters" element={<Navigate to="/diagnostics/specimens" replace />} />

        <Route path="diagnostics/categories" element={<DiagnosticsCategoriesPage />} />
        <Route path="diagnostics/categories/new" element={<CategoryFormPage />} />
        <Route path="diagnostics/categories/:id/edit" element={<CategoryFormPage />} />

        <Route path="diagnostics/specimens" element={<DiagnosticsSpecimensPage />} />
        <Route path="diagnostics/specimens/new" element={<SpecimenFormPage />} />
        <Route path="diagnostics/specimens/:id/edit" element={<SpecimenFormPage />} />

        <Route path="diagnostics/containers" element={<DiagnosticsContainersPage />} />
        <Route path="diagnostics/containers/new" element={<ContainerFormPage />} />
        <Route path="diagnostics/containers/:id/edit" element={<ContainerFormPage />} />

        <Route path="diagnostics/rejection-reasons" element={<DiagnosticsRejectionReasonsPage />} />
        <Route path="diagnostics/rejection-reasons/new" element={<RejectionReasonFormPage />} />
        <Route path="diagnostics/rejection-reasons/:id/edit" element={<RejectionReasonFormPage />} />

        <Route path="diagnostics/report-templates" element={<DiagnosticsReportTemplatesPage />} />
        <Route path="diagnostics/report-templates/new" element={<ReportTemplateFormPage />} />
        <Route path="diagnostics/report-templates/:id/edit" element={<ReportTemplateFormPage />} />

        <Route path="diagnostics/rooms" element={<DiagnosticsRoomsPage />} />
        <Route path="diagnostics/rooms/new" element={<RoomFormPage />} />
        <Route path="diagnostics/rooms/:id/edit" element={<RoomFormPage />} />

        <Route path="diagnostics/facilities" element={<DiagnosticsFacilitiesPage />} />
        <Route path="diagnostics/facilities/new" element={<FacilityFormPage />} />
        <Route path="diagnostics/facilities/:id/edit" element={<FacilityFormPage />} />
        <Route path="diagnostics/facility-load" element={<FacilityLoadPage />} />

        <Route path="diagnostics/machines" element={<DiagnosticsMachinesPage />} />
        <Route path="diagnostics/machines/new" element={<MachineFormPage />} />
        <Route path="diagnostics/machines/:id/edit" element={<MachineFormPage />} />

        <Route path="diagnostics/tests" element={<DiagnosticsLabTestsPage />} />
        <Route path="diagnostics/tests/new" element={<LabTestFormPage />} />
        <Route path="diagnostics/tests/:id/edit" element={<LabTestFormPage />} />

        <Route path="diagnostics/profiles" element={<DiagnosticsProfilesPage />} />
        <Route path="diagnostics/profiles/new" element={<ProfileFormPage />} />
        <Route path="diagnostics/profiles/:id/edit" element={<ProfileFormPage />} />
        <Route path="diagnostics/reflex-rules" element={<DiagnosticsReflexRulesPage />} />
        <Route path="diagnostics/orders" element={<DiagnosticOrdersListPage />} />
        <Route path="diagnostics/order-queue" element={<DiagnosticOrderQueuePage />} />
        <Route path="diagnostics/orders/new" element={<NewDiagnosticOrderPage />} />
        <Route path="diagnostics/samples" element={<DiagnosticSamplesPage />} />
        <Route path="diagnostics/collect" element={<SampleCollectionPage />} />
        <Route path="diagnostics/results" element={<DiagnosticResultsPage />} />
        <Route path="diagnostics/radiology-worklist" element={<RadiologyWorklistPage />} />
        <Route path="diagnostics/barcode" element={<BarcodePage />} />
        <Route path="diagnostics/lab-workbench" element={<LabWorkbenchPage />} />
        <Route path="diagnostics/critical-values" element={<CriticalValuesPage />} />
        <Route path="diagnostics/qc" element={<DiagnosticsQcPage />} />
        <Route path="diagnostics/radiology/modalities" element={<RadiologyModalitiesPage />} />
        <Route path="diagnostics/radiology/modalities/new" element={<ModalityFormPage />} />
        <Route path="diagnostics/radiology/modalities/:id/edit" element={<ModalityFormPage />} />
        <Route path="diagnostics/radiology/procedures" element={<RadiologyProceduresPage />} />
        <Route path="diagnostics/radiology/procedures/new" element={<ProcedureFormPage />} />
        <Route path="diagnostics/radiology/procedures/:id/edit" element={<ProcedureFormPage />} />
        <Route path="diagnostics/radiology/scheduling" element={<RadiologySchedulingPage />} />
        <Route path="diagnostics/radiology/reporting" element={<RadiologyReportingPage />} />
        {/* The old all-in-one Radiology screen split into the four routes above. */}
        <Route path="diagnostics/radiology" element={<Navigate to="/diagnostics/radiology/modalities" replace />} />
        <Route path="diagnostics/dispatch" element={<DispatchPage />} />
        <Route path="diagnostics/tat" element={<LabTatPage />} />
        <Route path="diagnostics/notifications" element={<DiagnosticsNotificationsPage />} />
        <Route path="diagnostics/microbiology" element={<DiagnosticsMicrobiologyPage />} />
        <Route path="diagnostics/histopathology" element={<DiagnosticsHistopathologyPage />} />
        <Route path="diagnostics/outsourced" element={<DiagnosticsOutsourcedPage />} />
        <Route path="diagnostics/radiology-safety" element={<DiagnosticsSafetyPage />} />
        <Route path="diagnostics/pacs" element={<DiagnosticsPacsPage />} />
        <Route path="diagnostics/critical-findings" element={<DiagnosticsCriticalFindingsPage />} />
        <Route path="diagnostics/lab-dashboard" element={<DiagnosticsLabDashboardPage />} />
        <Route path="diagnostics/radiology-dashboard" element={<DiagnosticsRadiologyDashboardPage />} />
        <Route path="diagnostics/analytics" element={<DiagnosticsAnalyticsHubPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
